import { Grid, Typography } from '@material-ui/core'

import { addCommaToPrice } from '../../helpers/numbers'
import { getTranslate } from '../../localization'
import { Wallet } from '../../types/wallet'
import { Proforma } from '../../types/walletProforma'
import { useStyles } from './styles/TransactionDetails'

interface TransactionDetailsProps {
  proforma: Proforma
  wallet: Wallet
}

const TransactionDetails: React.FC<TransactionDetailsProps> = ({
  proforma,
  wallet
}) => {
  const classes = useStyles()

  const numberOfTransactions = proforma.transactions.length

  const totalAmount = proforma.transactions.reduce(
    (sum, tx) => sum + tx.amount,
    0
  )

  const totalPenalty = proforma.transactions.reduce(
    (sum, tx) => sum + tx.sumOfPenalty,
    0
  )

  const totalBounce = proforma.transactions.reduce(
    (sum, tx) => sum + tx.rewardOfEarlyPayment,
    0
  )

  const currency = wallet.currency || 'IRR'

  return (
    <div className={classes.card}>
      <Grid container spacing={2}>
        <Grid item xs={6} className={classes.currencyDisplay}>
          <Typography variant="body2" className={classes.label}>
            {getTranslate('Number of Transactions')}
          </Typography>
          <Typography variant="body1" className={classes.value}>
            {numberOfTransactions}
          </Typography>
        </Grid>

        <Grid item xs={6} className={classes.currencyDisplay}>
          <Typography variant="body2" className={classes.label}>
            {getTranslate('Total Amount')}
          </Typography>
          <Typography variant="body1" className={classes.value}>
            {addCommaToPrice(totalAmount) + ' ' + currency}
          </Typography>
        </Grid>

        <Grid item xs={6} className={classes.currencyDisplay}>
          <Typography variant="body2" className={classes.label}>
            {getTranslate('Total Penalty')}
          </Typography>
          <Typography
            variant="body1"
            className={`${classes.value} ${classes.red}`}>
            {addCommaToPrice(-totalPenalty) + ' ' + currency}
          </Typography>
        </Grid>

        <Grid item xs={6} className={classes.currencyDisplay}>
          <Typography variant="body2" className={classes.label}>
            {getTranslate('Total Bounce')}
          </Typography>
          <Typography
            variant="body1"
            className={`${classes.value} ${classes.green}`}>
            {addCommaToPrice(totalBounce) + ' ' + currency}
          </Typography>
        </Grid>
      </Grid>
    </div>
  )
}

export default TransactionDetails
